import type { FC } from 'react';
import { useBlockActions } from '@ContractBuilder/modules/block-edit';
import { useEntityStore } from '@ContractBuilder/store';
import type { ResourceBlock } from '@root/@types/base';
import { isExcludedFromEndorsementPreview } from '@root/helpers/blocks';

import { EndorsementViewBlockActionsView } from '../views/EndorsementViewBlockActionsView';

interface EndorsementBlockActionsControllerProps {
  block: ResourceBlock;
}

export const EndorsementBlockActionsController: FC<EndorsementBlockActionsControllerProps> = ({ block }) => {
  const submission = useEntityStore(({ submission }) => submission);
  const { hideBlockFromPreview, showBlockInPreview } = useBlockActions();

  const isHidden = isExcludedFromEndorsementPreview(block, submission);

  const handleToggleChangeVisibility = () =>
    isHidden ? showBlockInPreview({ blockId: block.id }) : hideBlockFromPreview({ blockId: block.id });

  return (
    <EndorsementViewBlockActionsView
      block={block}
      isHidden={isHidden}
      onToggleChangeVisibility={handleToggleChangeVisibility}
    />
  );
};
